// extracted by mini-css-extract-plugin
export default {"storyContainer":"Story_storyContainer__Sf923","line":"Story_line__Gynuc"};